import { groupingOptions } from '~/constants/cardViewSettings';
import { capitalize } from '~/utils/strings';
import { toPluralEntity } from '~/utils/linePlanEntity';
import { Trash } from 'lucide-react';
export function buildSavedViewsMenu(args) {
    const subitems = [];
    subitems.push({
        label: 'Save Current View',
        id: 'save-current-view',
        onClick: () => args.onSaveCurrentView()
    });
    subitems.push({ separator: true, label: 'Separator0', id: 'Separator0' });
    if (args.savedViewsLoadingState === 'hasData' &&
        args.menuReadySavedViews?.length > 0) {
        args.menuReadySavedViews.forEach((group) => {
            subitems.push({
                label: group.listName,
                id: group.listName,
                sub: group.savedViews.map((savedView) => ({
                    label: savedView.name,
                    id: savedView.projectId,
                    onClick: () => args.onSelectView(savedView.projectId, savedView.name),
                    selected: savedView.isActive,
                    suffix: savedView.isActive ? 'current view' : undefined,
                    ...(savedView.canDelete && {
                        actionIcon: Trash,
                        onAction: () => {
                            args.onDeleteView(savedView.projectId, savedView.name);
                        }
                    })
                }))
            });
        });
    }
    else if (args.savedViewsLoadingState === 'hasData') {
        const entityLabel = capitalize(toPluralEntity(args.entityType));
        subitems.push({
            label: `No saved views for ${entityLabel}`,
            id: 'no-views',
            disabled: true
        });
    }
    else {
        subitems.push({
            label: 'Loading saved views...',
            id: 'loading',
            disabled: true
        });
    }
    subitems.push({ separator: true, label: 'Separator1', id: 'Separator1' });
    subitems.push({
        label: 'Manage Saved Views',
        id: 'manage-saved-views',
        url: '/manage-saved-views'
    });
    return {
        label: `${capitalize(toPluralEntity(args.entityType))} Saved Views`,
        id: 'saved-views',
        sub: subitems
    };
}
export function buildGridSettingsMenu(args) {
    const menu = [];
    if (args.savedViewsMenu) {
        menu.push(args.savedViewsMenu);
        menu.push({ separator: true, label: 'Separator0', id: 'Separator0' });
    }
    menu.push({
        label: 'Grid Configuration',
        id: 'grid-configuration',
        onClick: () => args.onOpenColumnsPanel()
    });
    return menu;
}
export function buildCardSettingsMenu(args) {
    const { currentScale, currentGroupBy, currentViewType } = args;
    const baseMenu = [];
    if (args.savedViewsMenu) {
        baseMenu.push(args.savedViewsMenu);
        baseMenu.push({ separator: true, label: 'Separator0', id: 'Separator0' });
    }
    const sizeItems = ['small', 'medium', 'large'].map((size) => ({
        label: capitalize(size),
        id: `card-size-${size}`,
        onClick: () => args.onScaleChange(size),
        selected: currentScale === size
    }));
    const groupByItems = groupingOptions.map((opt) => ({
        label: opt.label,
        id: `group-by-${opt.value}`,
        onClick: () => args.onGroupByChange(opt.value),
        selected: currentGroupBy === opt.value
    }));
    const viewTypeOptions = [
        { value: 'standard', label: 'Standard' },
        { value: 'timeline', label: 'Timeline' },
        { value: 'pivot', label: 'Pivot' },
        { value: 'kanban', label: 'Kanban' }
    ];
    const viewTypeItems = viewTypeOptions.map((opt) => ({
        label: opt.label,
        id: `view-type-${opt.value}`,
        onClick: () => args.onViewTypeChange(opt.value),
        selected: currentViewType === opt.value
    }));
    baseMenu.push({ label: 'Card size', id: 'card-size', sub: sizeItems });
    baseMenu.push({ separator: true, label: 'Separator1', id: 'Separator1' });
    baseMenu.push({ label: 'Group by', id: 'group-by', sub: groupByItems });
    baseMenu.push({ separator: true, label: 'Separator2', id: 'Separator2' });
    baseMenu.push({ label: 'View type', id: 'view-type', sub: viewTypeItems });
    if (args.includeCustomGroupActions) {
        baseMenu.push({ separator: true, label: 'Separator3', id: 'Separator3' });
        baseMenu.push({
            label: 'Custom groups',
            id: 'custom-groups',
            sub: [
                {
                    label: 'Add group',
                    id: 'custom-groups-add',
                    onClick: () => args.onAddGroup && args.onAddGroup()
                },
                {
                    label: 'Manage order',
                    id: 'custom-groups-manage-order',
                    onClick: () => args.onManageOrder && args.onManageOrder()
                }
            ]
        });
    }
    return baseMenu;
}
